export function featuredProjectsBigSlider() {
    let $slider = $('.featured-projects-big-slider');
    let $counterHolder = $slider.parent();
    let $counterCurrent = $counterHolder.find(".global-counter-current");
    let $counterLength = $counterHolder.find(".global-counter-length");
    $slider.slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        speed: 500,
        cssEase: 'linear',
        nextArrow: $counterHolder.find(".global-counter-slider-next-big")
    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
        counterSlides();
    });

    function counterSlides() {
        $counterCurrent.text($slider.find(".slick-dots li.slick-active").index() + 1);
        $counterLength.text($slider.find(".slick-dots li").length);
    }

    $(window).on("load resize", function () {
        setTimeout(function () {
            counterSlides();
        }, 100);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/featuredProjectsBigSlider.js